/******************************************************************************
 * Created Date: Thursday Febuary 10th 2022                                   *
 * Author: Jan A.                                                             *
 * -----                                                                      *
 * Last Modified: Thu Feb 17 2022                                             *
 * Modified By: Jan A.                                                        *
 * -----                                                                      *
 * File: /src/components/account/Users/components/List/index.jsx              *
 * Copyright (c) 2021 Kuva                                                    *
 ******************************************************************************/

import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";

import { ToolBar } from "~/components/account/Users/components";

import MakeColumns from "./MakeColumns";

const List = ({
  loading,
  users,
  openMenu,
  closeMenu,
  menuAnchor,
  onClickEdit,
  searchText,
  requestSearch,
  setOpenFormDialog
}) => {
  return (
    <div style={{ display: "flex", height: "100%" }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          loading={loading}
          rowHeight={54}
          rows={users}
          columns={MakeColumns({
            openMenu,
            closeMenu,
            menuAnchor,
            onClickEdit
          })}
          components={{ Toolbar: ToolBar }}
          componentsProps={{
            toolbar: {
              value: searchText,
              onChange: event => requestSearch(event.target.value),
              clearSearch: () => requestSearch(""),
              setOpenFormDialog: setOpenFormDialog
            }
          }}
        />
      </div>
    </div>
  );
};

List.defaultProps = {
  loading: false,
  users: []
};

List.propTypes = {
  loading: PropTypes.bool.isRequired,
  users: PropTypes.array.isRequired
};

export default List;
